<template>
  <div class="mod-config" style="height: 100%">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item style="float: left;" label="唯一编码：">
        <el-input v-model="dataForm.key" placeholder="唯一编码" clearable></el-input>
      </el-form-item>
      <el-form-item style="float: left;">
        <label>选择时间：</label>
        <el-date-picker v-model="dataForm.dateStr" :picker-options="dataForm.pickerOptions" type="datetimerange"
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :format="dataForm.formatTime"
          :value-format="dataForm.formatTime">
        </el-date-picker>
      </el-form-item>
      <el-form-item style="float: left;" label="处理状态：">
        <template>
          <el-select v-model="dataForm.status" clearable placeholder="请选择">
            <el-option v-for="item in dealOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-form-item>
      <el-button @click="search()" type="primary" icon="el-icon-search" style="float: left;"></el-button>
      <el-form-item style="float: right;">
        <el-button type="success" @click="tempExcel()">导出Excel</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="dataList" border v-loading="dataListLoading" @selection-change="selectionChangeHandle"
      style="width: 100%;" height="calc(100% - 120px)" border stripe :header-cell-style="{background:'#FAFAFA'}"
      placement="top">
      <el-table-column type="selection" header-align="center" align="center" width="50">
      </el-table-column>
      <el-table-column prop="id" header-align="center" align="center" label="ID">
      </el-table-column>
      <el-table-column prop="deviceCode" header-align="center" align="center" label="设备唯一编码">
      </el-table-column>
      <el-table-column prop="typeName" header-align="center" align="center" label="处理方式">
      </el-table-column>
      <el-table-column prop="" header-align="center" align="center" label="数据串" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-clipboard:copy="scope.row.rawData" v-clipboard:success="onCopy" v-clipboard:error="onError"
            style="cursor: pointer;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{scope.row.rawData}}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="uploadTime" header-align="center" align="center" label="上传时间" sortable>
      </el-table-column>
      <el-table-column prop="statusName" header-align="center" align="center" label="处理状态">
      </el-table-column>
    </el-table>
    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
      layout="prev, pager, next, jumper, total,sizes">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </div>
</template>
<style>
  .el-tooltip__popper {
    max-width: 50%;
  }
</style>
<script>
import AddOrUpdate from './deviceDataTemp-add-or-update'

import {excel} from "@/utils";

export default {
  data() {
    return {
      dataForm: {
        key: '',
        dateFromStr: '',
        dateToStr: '',
        dateStr:'',
        formatTime: "yyyy-MM-dd HH:mm",
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > new Date()
          }
        }
      },
      dataList: [],
      dealOptions: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false
    }
  },
  components: {
    AddOrUpdate
  },
  created() {
    // this.getDataList()
    this.getStatusOption()
  },
  methods: {
    onCopy: function (e) {
      this.$message.success('复制成功: ' + e.text)
    },
    onError: function (e) {
      this.$message.error('复制失败')
    },
    search(){
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      if (this.dataForm.dateStr) {
        this.dataForm.dateFromStr = this.dataForm.dateStr[0]
        this.dataForm.dateToStr = this.dataForm.dateStr[1]
      }
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/deviceDataTemp/list'),
        method: 'get',
        params: this.$http.adornParams({
          'pageNum': this.pageIndex,
          'pageSize': this.pageSize,
          'params': this.dataForm.key,
          'status': this.dataForm.status,
          dateFromStr: this.dataForm.dateFromStr,
          dateToStr: this.dataForm.dateToStr,
        })
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.dataList = data.data.rows
          this.totalPage = data.data.total
        } else {
          this.dataList = []
          this.totalPage = 0
          this.$message.error(data.msg)
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    //导出excel
    tempExcel() {
      excel("/deviceDataTemp/excel", "数据上传信息-" + this.$moment(new Date()).format("yyyyMMDDHHmm"), {
        'pageNum': this.pageIndex,
        'pageSize': this.pageSize,
        'params': this.dataForm.key,
        'status': this.dataForm.status
      })
    },
    //获取处理状态
    getStatusOption() {
      this.$http({
        url: this.$http.adornUrl("/configOption/option/4"),
        method: 'get'
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.dealOptions = data.data.enumOption
        }
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/backstagefunction/deviceDataTemp.vue